var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707521 2.70697C0.317733 2.31718 0.319859 1.68308 0.707825 1.29512L0.79567 1.20727C1.18563 0.817315 1.81526 0.814702 2.20973 1.20918L7.29376 6.29321C7.68477 6.68422 7.68824 7.3147 7.29376 7.70918L2.20973 12.7932C1.81872 13.1842 1.18364 13.1831 0.79567 12.7951L0.707825 12.7073C0.317869 12.3173 0.31452 11.6884 0.707521 11.2954L5.00175 7.00119L0.707521 2.70697Z",
    fill: "#161C28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.a5a9967ade5803e357829fd887f00899.svg";
export { ForwardRef as ReactComponent };